import {Observable} from 'rxjs';
import {filter}     from 'rxjs/operators';

import MediaEventType            from '../Constants/MediaEventType';
import SyntheticMediaEventType   from '../Constants/SyntheticMediaEventType';
import IMediaEventsStreamPayload from '../Interfaces/IMediaEventsStreamPayload';

const createMediaReadyStream = (
    mediaEvents$: Observable<IMediaEventsStreamPayload>
): Observable<IMediaEventsStreamPayload> =>
    mediaEvents$
        .pipe(
            filter(({type}) =>
                [
                    MediaEventType.LOADED_META_DATA,
                    SyntheticMediaEventType.READY
                ].includes(type)
            )
        );

export default createMediaReadyStream;